import React, {useEffect, useState} from "react";
import {
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import {FaGlobe, FaLanguage} from 'react-icons/fa';

import WebApp from "@twa-dev/sdk";
import SettingItem from "./SettingItem";
import {useTranslation} from "react-i18next";

function SettingsPage() {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const TIME_ZONES = [
        {label: 'Etc/GMT+12', value: 'Etc/GMT+12'},
        {label: 'Pacific/Honolulu', value: 'Pacific/Honolulu'},
        {label: 'America/Anchorage', value: 'America/Anchorage'},
        {label: 'America/Los_Angeles', value: 'America/Los_Angeles'},
        {label: 'America/Denver', value: 'America/Denver'},
        {label: 'America/Chicago', value: 'America/Chicago'},
        {label: 'America/New_York', value: 'America/New_York'},
        {label: 'America/Halifax', value: 'America/Halifax'},
        {label: 'America/Argentina/Buenos_Aires', value: 'America/Argentina/Buenos_Aires'},
        {label: 'Atlantic/South_Georgia', value: 'Atlantic/South_Georgia'},
        {label: 'Atlantic/Azores', value: 'Atlantic/Azores'},
        {label: 'UTC', value: 'UTC'},
        {label: 'Europe/Berlin', value: 'Europe/Berlin'},
        {label: 'Europe/Athens', value: 'Europe/Athens'},
        {label: 'Europe/Moscow', value: 'Europe/Moscow'},
        {label: 'Asia/Dubai', value: 'Asia/Dubai'},
        {label: 'Asia/Karachi', value: 'Asia/Karachi'},
        {label: 'Asia/Dhaka', value: 'Asia/Dhaka'},
        {label: 'Asia/Bangkok', value: 'Asia/Bangkok'},
        {label: 'Asia/Shanghai', value: 'Asia/Shanghai'},
        {label: 'Asia/Tokyo', value: 'Asia/Tokyo'},
        {label: 'Australia/Sydney', value: 'Australia/Sydney'},
        {label: 'Pacific/Noumea', value: 'Pacific/Noumea'},
        {label: 'Pacific/Kiritimati', value: 'Pacific/Kiritimati'}
    ];

    const LANGUAGE_OPTIONS = [
        {label: '🇷🇺 Русский', value: 'ru'},
        {label: '🇺🇸 English', value: 'en'}
    ]

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const initData = WebApp?.initData;

            const response = await fetch("/api/ai-notification/settings", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Telegram-InitData": initData ?? "",
                }
            });

            if (!response.ok) throw new Error("Request failed");

            const data = await response.json();
            setSettings(data);
        } catch (error) {

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);


    const updateLangSettings = async (value: string) => {
        try {
            const initData = WebApp?.initData;

            const response = await fetch("/api/ai-notification/settings/language", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-Telegram-InitData": initData ?? ""
                },
                body: JSON.stringify({value: value})
            });

            if (!response.ok) throw new Error("Request failed");

            const data = await response.json();
            setSettings(data);
        } catch (error) {

        } finally {
        }
    };


    const updateTimeZoneSettings = async (value: string) => {
        try {
            const initData = WebApp?.initData;

            const response = await fetch("/api/ai-notification/settings/timezone", {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-Telegram-InitData": initData ?? "",
                },
                body: JSON.stringify({value: value})
            });

            if (!response.ok) throw new Error("Request failed");

            const data = await response.json();
            setSettings(data);
        } catch (error) {

        } finally {
        }
    };


    return (
        <Box maxW="400px" mx="auto">
            <Text fontSize="2xl" fontWeight="bold" mb={4}>
                {t('settings.settings')}
            </Text>

            <VStack align="stretch">
                {/*        @ts-ignore*/}
                <SettingItem update={updateTimeZoneSettings} value={TIME_ZONES.find(i => i.value === settings?.timeZone)} icon={FaGlobe}
                             options={TIME_ZONES}  label={t('settings.timeZone')}/>
                {/*        @ts-ignore*/}
                <SettingItem update={updateLangSettings} value={LANGUAGE_OPTIONS.find(i => i.value === settings?.language)} icon={FaLanguage}
                             options={LANGUAGE_OPTIONS}  label={t('settings.language')}/>
            </VStack>
        </Box>
    );
};


export default SettingsPage;
